import { useContext } from 'react'

import {
  Button, Columns, LoadingModule, SaveFormModule,
} from '@domain-group/suit-theme'

import useSystem, { useSystemForm } from '@hooks/useSystem'

import PageContext from '@contexts/pageContext'

import DataStoreItemKeys from '../DataStoreItemKeys'
import PageLayout from '../../../../components/PageLayout'
import SystemTools from '../../../../components/SystemTools'
import TemplateQualityControlCategories from '../TemplateQualityControlCategories'

import PaymentsAndAccounts from '../PaymentsAndAccounts'
import SystemDetails from '../SystemDetails'
import SystemOptions from '../SystemOptions'
import SystemSettings from '../SystemSettings'

const PageContent = (props: { systemId: number}) => {
  const { systemId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateSystem,
    },
  } = pageContext

  const systemPayload = useSystem({ id: systemId })
  const {
    callbacks: {
      updateSystem: updateFn,
    },
    system,
    loading,
    updating,
  } = systemPayload

  const systemFormPayload = useSystemForm(system, { validateOn: 'change' })
  const { entityState, saveEnabled } = systemFormPayload

  const updateSystemPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'System Updated',
  }

  return (
    <PageLayout entityPayload={systemPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <SystemDetails systemFormPayload={systemFormPayload} />

            <PaymentsAndAccounts systemFormPayload={systemFormPayload} />

            <SystemOptions systemFormPayload={systemFormPayload} />

            <DataStoreItemKeys systemPayload={systemPayload} />

            <TemplateQualityControlCategories systemPayload={systemPayload} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                //@ts-expect-error
                marginLeft="auto"
                onClick={() => updateSystem(updateSystemPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <SystemTools systemPayload={systemPayload} />

        <SystemSettings systemPayload={systemPayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
